import { render, staticRenderFns } from "./StudentNoteFormView.vue?vue&type=template&id=a7838e1a&scoped=true"
import script from "./StudentNoteFormView.vue?vue&type=script&lang=js"
export * from "./StudentNoteFormView.vue?vue&type=script&lang=js"
import style0 from "./StudentNoteFormView.vue?vue&type=style&index=0&id=a7838e1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7838e1a",
  null
  
)

export default component.exports